/* unplugin-vue-components disabled */import { render } from "./Header.vue?vue&type=template&id=fc268692"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=fc268692&lang=css"

import exportComponent from "E:\\projects\\git\\company\\www_dixiang\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__